'use client';
import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createTranslator, localizeHref, translateContent, type Locale, type Messages } from '@/lib/i18n/core';
function valueFor(locale: Locale, messages: Messages) {
  const t = createTranslator(messages);
  const cache = new WeakMap<object, unknown>();
  return { locale, t, href: (path: string) => localizeHref(path, locale), content: <T,>(value: T): T => {
    if (!value || typeof value !== 'object') return translateContent(value, t);
    if (!cache.has(value)) cache.set(value, translateContent(value, t));
    return cache.get(value) as T;
  } };
}
const LocaleContext = createContext(valueFor('fr', {}));
export const useI18n = () => useContext(LocaleContext);
export default function LocaleProvider({ locale, messages, children }: { locale: Locale; messages: Messages; children: ReactNode }) {
  const value = useMemo(() => valueFor(locale, messages), [locale, messages]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
